import { connect } from 'react-redux';
import config from 'config';
import { formatBase64ToSrc } from 'shared/utils/formatBase64ToSrc';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import getOrganizationLogo from 'modules/auth/selectors/getOrganizationLogo';
import checkIsMobile, { isInStandaloneMode } from 'shared/utils/checkMobileDevice';
import { conferenceInProgress } from 'modules/conference/selectors/consultationInfo';
import { getAppointmentDetails } from 'modules/appointmentInfo/selectors/currentAppointmentDetails';

import ScheduleConferencePage from './ScheduleConferencePage';


export default connect(
  state => {
    const isAppointmentFetched = state.appointmentInfo.currentAppointment.requestStatus === requestsStatuses.success;

    return {
      isMobile: checkIsMobile(),
      logoAlt: 'Organization Logo',
      idleTime: Number(config.idle_time),
      isInStandaloneMode: isInStandaloneMode(),
      isAppointmentFetching: !isAppointmentFetched,
      isConferenceInProgress: conferenceInProgress(state),
      logoSrc: formatBase64ToSrc(getOrganizationLogo(state)),
      appointment: isAppointmentFetched ? getAppointmentDetails(state) : {},
      isAppointmentInfoShown: state.queues.common.appointmentInfo.isAppointmentInfoShown,
    };
  },
)(ScheduleConferencePage);
